module.exports = __webpack_public_path__ + "img/18-2 iPhone RedteaGo App for iPhone eSIM.4aa2e647.png";